export default __webpack_public_path__ + "static/media/D-Icon.47f98eeb.png";